import { useState } from 'react';
import { Badge } from '@shared/ui/Badge';
import type { KadryRegistryRow } from '@entities/kadry';
import { KadryOutreachChat } from '../../ui';
import {
  Row,
  Score,
  Main,
  Headline,
  Tags,
  Small,
  Contacts,
  NoteToggle,
} from './styles';
import { SOURCE_TITLE } from './types';
import { OutreachState } from './OutreachState';

export function CandidateRow(props: {
  row: KadryRegistryRow;
  requestId: string;
  canSend: boolean;
  canMark: boolean;
}) {
  const { row } = props;
  const m = row.match;
  const o = row.outreach;
  const [notesOpen, setNotesOpen] = useState(false);
  // Переписка у «Подходит» видна всегда. У остальных, кому ушло предложение,
  // — когда пометки уже есть или кадровик открыл поле: обзванивают тех, кто
  // ещё не ответил, и помечают, до кого дозвонились.
  const showChat = o != null && (o.response === 'interested' || row.comments.length > 0 || notesOpen);
  const tags: string[] = [];
  if (row.analysis_route === 'external') tags.push('Разобрано DeepSeek');
  if (!row.analyzed) tags.push('Предварительно, по выдаче');
  return (
    <Row $alert={row.outreach?.hr_not_contacted}>
      <Score $score={m.score} title="Балл соответствия профилю (0–100)">
        {Math.round(m.score)}
      </Score>
      <Main>
        <Headline>{row.headline ?? 'Резюме без названия должности'}</Headline>
        <Tags>
          <Badge $tone="neutral">{SOURCE_TITLE[m.source] ?? m.source}</Badge>
          {row.applied && <Badge $tone="success">Откликнулся сам</Badge>}
          {row.experience_years != null && (
            <Badge $tone="info">опыт в роли {Math.round(row.experience_years)} г.</Badge>
          )}
          {tags.map((t) => (
            <Badge key={t} $tone="neutral">
              {t}
            </Badge>
          ))}
        </Tags>
        {m.explanation_safe && <Small>{m.explanation_safe}</Small>}
        {!m.passed_filters && (
          <Small>
            Не прошёл обязательные требования:{' '}
            {m.hard_filters
              .map((f) =>
                f.kind === 'permit_missing' ? `нет допуска «${f.requirement}»` : 'отказ от условий',
              )
              .join(', ')}
          </Small>
        )}
        {(row.full_name || row.phones.length > 0 || row.emails.length > 0 || row.resume_url) && (
          <Contacts>
            {row.full_name && <div>{row.full_name}</div>}
            {row.phones.map((p) => (
              <div key={p}>
                <a href={`tel:+${p.replace(/\D/g, '')}`}>+{p.replace(/\D/g, '')}</a>
              </div>
            ))}
            {row.emails.map((e) => (
              <div key={e}>
                <a href={`mailto:${e}`}>{e}</a>
              </div>
            ))}
            {row.resume_url && (
              <div>
                <a href={row.resume_url} target="_blank" rel="noreferrer">
                  Резюме на hh.ru
                </a>
              </div>
            )}
          </Contacts>
        )}
        {o && showChat && (
          <KadryOutreachChat
            outreach={o}
            comments={row.comments}
            requestId={props.requestId}
            canWrite={props.canMark}
            autoFocus={notesOpen}
          />
        )}
        {o && !showChat && props.canMark && (
          <NoteToggle type="button" onClick={() => setNotesOpen(true)}>
            Добавить пометку
          </NoteToggle>
        )}
      </Main>
      <OutreachState {...props} />
    </Row>
  );
}
